import React from 'react';
import { FaGithub, FaDownload, FaLinkedin, FaInstagram, FaTwitter, FaArrowRight } from 'react-icons/fa';
import Pattern from './components/Pattern';
import FeatureCard from './components/FeatureCard';
import styled from 'styled-components';

function App() {
  return (
    <div className="min-h-screen text-white relative">
      <Pattern />
      {/* Hero Section */}
      <header className="container mx-auto px-4 py-12 sm:py-16 md:py-20 text-center">
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="WTFShade" className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 mx-auto mb-8 sm:mb-10 md:mb-12" />
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 sm:mb-5 md:mb-6 text-white">
          WTFShade
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-6 sm:mb-7 md:mb-8 max-w-2xl mx-auto">
          A modern color picker extension for your favorite browser with instant format copying
        </p>
        <a 
          href={`${process.env.PUBLIC_URL}/WTFShade.zip`}
          download="WTFShade.zip"
          className="inline-flex items-center px-6 sm:px-7 md:px-8 py-3 sm:py-3.5 md:py-4 bg-[#2563eb] hover:bg-[#1d4ed8] rounded-lg transition-colors gap-2 sm:gap-3 text-base sm:text-lg text-white shadow-lg"
        >
          <FaDownload className="text-xl" /> Download Extension
        </a>
      </header>

      {/* Features */}
      <section className="py-12 sm:py-14 md:py-16">
        <h2 className="text-3xl sm:text-3xl md:text-4xl font-bold mb-10 sm:mb-12 md:mb-16 text-center text-white">Features</h2>
        <div className="max-w-xl mx-auto px-4 sm:px-6 md:px-8">
          <FeatureCard
            title="Features"
            features={[
              "Copy colors in HEX, RGB, HSL, and CMYK formats",
              "Modern dark interface that's easy on the eyes",
              "Track and access your recently used colors",
              "Instantly copy any color format to clipboard"
            ]}
          />
        </div>
      </section>

      {/* Installation Guide */}
      <section className="py-12 sm:py-14 md:py-16">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          <h2 className="text-3xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-9 md:mb-10 text-center text-white">Installation Guide</h2>
          <div className="max-w-3xl mx-auto space-y-4 sm:space-y-5 md:space-y-6">
            <Step number="1" text="Download the extension ZIP file" />
            <Step number="2" text="Unzip the downloaded file" />
            <Step number="3" text="Open your browser's extension page" />
            <Step number="4" text="Enable Developer mode (top right)" />
            <Step number="5" text="Click Load unpacked and select the unzipped folder" />
          </div>
        </div>
      </section>

      {/* About Developer */}
      <section className="py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-10 text-center text-white">About the Developer</h2>
          <StyledWrapper>
            <div className="card">
              <div className="img">
                <img src={`${process.env.PUBLIC_URL}/your-photo.jpg`} alt="Rashmina Fernando" className="profile-img" />
              </div>
              <span>Rashmina Fernando</span>
              <p className="info">Frontend Developer & UI/UX Enthusiast passionate about creating intuitive and engaging user experiences.</p>
              <div className="share">
                <a href="https://github.com/RashminaFdo" target="_blank" rel="noopener noreferrer">
                  <FaGithub />
                </a>
                <a href="https://www.linkedin.com/in/rashminafernando/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin />
                </a>
                <a href="https://www.instagram.com/rashmina.fernando" target="_blank" rel="noopener noreferrer">
                  <FaInstagram />
                </a>
                <a href="https://x.com/rashminaf" target="_blank" rel="noopener noreferrer">
                  <FaTwitter />
                </a>
              </div>
              <a href="https://rashminafdo.github.io/Portfolio/" className="portfolio-btn" target="_blank" rel="noopener noreferrer">
                Portfolio <FaArrowRight className="arrow-icon" />
              </a>
            </div>
          </StyledWrapper>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 text-center text-gray-300">
        <p>Made with ❤️ by Rashmina Fernando</p>
      </footer>
    </div>
  );
}

function Step({ number, text }) {
  return (
    <div className="flex items-center gap-3 sm:gap-4 md:gap-6 bg-[#2a2a2a] p-4 sm:p-5 md:p-6 rounded-lg sm:rounded-xl shadow-lg hover:bg-[#333333] transition-all duration-300">
      <span className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 bg-[#2563eb] rounded-full flex items-center justify-center font-bold text-base sm:text-lg">
        {number}
      </span>
      <p className="text-base sm:text-lg text-gray-300">{text}</p>
    </div>
  );
}

function SocialLink({ href, icon }) {
  return (
    <a 
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-3xl text-white hover:text-gray-300 transition-colors"
    >
      {icon}
    </a>
  );
}

const StyledWrapper = styled.div`
  .card {
    width: 90%;
    max-width: 17em;
    height: auto;
    padding: 1.5em;
    @media (min-width: 640px) {
      padding: 1.75em;
    }
    @media (min-width: 768px) {
      padding: 2em;
    }
    background: #2a2a2a;
    transition: 1s ease-in-out;
    clip-path: polygon(30px 0%, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%, 0% 30px);
    border-top-right-radius: 20px;
    border-bottom-left-radius: 20px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
  }

  .card span {
    font-weight: bold;
    color: white;
    text-align: center;
    display: block;
    font-size: 1em;
    @media (min-width: 640px) {
      font-size: 1.1em;
    }
    @media (min-width: 768px) {
      font-size: 1.2em;
    }
    margin-top: 1em;
  }

  .card .info {
    font-weight: 400;
    color: #808080;
    display: block;
    text-align: center;
    font-size: 0.8em;
    @media (min-width: 640px) {
      font-size: 0.85em;
    }
    @media (min-width: 768px) {
      font-size: 0.9em;
    }
    margin: 1em;
    line-height: 1.5;
  }

  .card .img {
    width: 5em;
    height: 5em;
    @media (min-width: 640px) {
      width: 6em;
      height: 6em;
    }
    @media (min-width: 768px) {
      width: 7em;
      height: 7em;
    }
    background: #000000;
    border-radius: 50%;
    margin: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    &::after {
      content: '';
      position: absolute;
      inset: -3px;
      border-radius: 50%;
      background: linear-gradient(45deg, #2563eb, #1d4ed8);
      z-index: -1;
    }
  }

  .profile-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    background: #000000;
  }

  .card .share {
    margin-top: 1em;
    display: flex;
    justify-content: center;
    gap: 1em;
  }

  .card a {
    color: white;
    transition: .4s ease-in-out;
    font-size: 1.2em;
  }

  .card a:hover {
    color: #2563eb;
  }

  .portfolio-btn {
    padding: 0.6em 1.4em;
    @media (min-width: 640px) {
      padding: 0.7em 1.5em;
    }
    @media (min-width: 768px) {
      padding: 0.8em 1.7em;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: 1em auto 0;
    border-radius: 25px;
    font-weight: bold;
    background: #2563eb;
    color: white !important;
    text-decoration: none;
    transition: .4s ease-in-out;
    gap: 0.5em;
    font-size: 1em !important;
  }

  .portfolio-btn:hover {
    background: #1d4ed8;
    transform: translateY(-2px);
    
    .arrow-icon {
      transform: translateX(4px);
    }
  }

  .arrow-icon {
    transition: transform 0.3s ease;
  }
`;

export default App; 